/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import config from '../../tailwind.config';

export const PHONE_REGEXP = /\d{10}/g;
export const PHONE_DASHES_REGEXP = /\d{3}-\d{3}-\d{4}/g;
export const PHONE_BRACKETS_REGEXP = /\(\d{3}\)\s\d{3}-\d{4}/g;
/* eslint-disable no-useless-escape */
export const EMAIL_REGEXP =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const URL_REGEXP =
    /^https?:\/\/((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(\#[-a-z\d_]*)?$/gi;

export const isValidURL = (url: string): boolean => {
    const urlPattern: RegExp = new RegExp(URL_REGEXP, 'i');
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
        return false;
    }

    return urlPattern.test(url);
};

export const getUrlParam = (name: string) => {
    if (typeof window === 'undefined') return;
    const parameters = new URLSearchParams(window.location.search);
    return parameters.get(name);
};

export const addUrlParam = (url: string, key: string, value: string | boolean | undefined) => {
    if (url !== null && url !== undefined) {
        const reg = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
        const separator = url.indexOf('?') !== -1 ? '&' : '?';
        if (value) {
            if (typeof value === 'boolean') {
                value = 'true';
            }
            if (url.match(reg)) {
                return url.replace(reg, `$1${key}=${value}$2`);
            }
            return `${url}${separator}${key}=${value}`;
        }
        if (url.match(reg)) {
            return url.replace(reg, '');
        }
    }
    return url;
};

export const generalRedirect = (url: string, allid: string, isSMB = false) => {
    if (!allid) {
      throw new Error('Missing Alliance ID')
    }
  
    const allidURL = new URL(url);

    if (!isSMB) {
        allidURL.searchParams.append('allid', allid);
    }

    window.location.assign(allidURL);
  }

// redirects zip form submission and tools to EHMP
export function redirectToEhmp(
    params: BrowsePlansParameters,
    urlOverride: string | null = '',
    isLoggedIn = false
) {
    let redirectUrl = urlOverride || process.env.GATSBY_EHMP_URL;
    redirectUrl = constructUrl(params, redirectUrl);

    if (isLoggedIn) {
        redirectUrl = `${
            process.env.GATSBY_CC_GQL_URL
        }/web/redirect?redirectURL=${encodeURIComponent(redirectUrl)}`;
    }

    setVisitedQuotePageCookie();

    generalRedirect(redirectUrl, params.allid);
}

// sets the cookie indicating user was redirected to quote page
export function setVisitedQuotePageCookie(): void {
    // save profile.visitedQuotePage=true cookie
    setCookie('profile.visitedQuotePage', 'true', 14);
}

// adds parameters to anchors with EHMP link
export const addParamsToEhmpLink = (
    currentTarget: HTMLAnchorElement,
    extraParams: BrowsePlansParameters,
    isLoggedIn = false
) => {
    let ehmpUrl = currentTarget.href;
    const params = extraParams;
    if (!ehmpUrl.includes(process.env.GATSBY_EHMP_URL)) {
        return;
    }

    ehmpUrl = constructUrl(params, ehmpUrl);

    if (isLoggedIn) {
        currentTarget.href = `${
            process.env.GATSBY_CC_GQL_URL
        }/web/redirect?redirectURL=${encodeURIComponent(ehmpUrl)}`;
    } else {
        currentTarget.href = ehmpUrl;
    }
};

const constructUrl = (params: BrowsePlansParameters, url: string) => {
    if (params.fastQuote) {
        url += 'ehi/medicare/fast-quote';
        url = addUrlParam(url, 'requestFromFQ', 'true');
        url = addUrlParam(url, 'forceV1', 'true');
        url = addUrlParam(url, 'fastQuoteV2', 'Y');
        delete params.fastQuote;
    }

    if (typeof window._satellite !== 'undefined') {
        window._satellite.getVar('Cross Domain Parameters')?.forEach((param) => {
            params[param.key] = param.value;
        });
    }

    const requestFromParam = getUrlParam('requestFrom');
    if (requestFromParam) {
        url = addUrlParam(url, 'requestFrom', requestFromParam);
    }

    const targetParam = getUrlParam('target');
    if (targetParam) {
        url = addUrlParam(url, 'target', targetParam);
    }

    (Object.keys(params) as Array<keyof BrowsePlansParameters>).forEach((key) => {
        if (key === 'planYear') {
            if (!url.includes('planYear=')) {
                url = addUrlParam(url, key, params[key]);
            }
        } else {
            url = addUrlParam(url, key, params[key]);
        }
    });
    return url;
};

export const slideUp = (target: HTMLElement, duration = 600) => {
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = `${duration}ms`;
    target.style.boxSizing = 'border-box';
    target.style.height = `${target.offsetHeight}px`;
    target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = '0';
    target.style.paddingTop = '0';
    target.style.paddingBottom = '0';
    target.style.marginTop = '0';
    target.style.marginBottom = '0';
    if (typeof window !== 'undefined') {
        window.setTimeout(() => {
            target.style.display = 'none';
            target.style.removeProperty('height');
            target.style.removeProperty('padding-top');
            target.style.removeProperty('padding-bottom');
            target.style.removeProperty('margin-top');
            target.style.removeProperty('margin-bottom');
            target.style.removeProperty('overflow');
            target.style.removeProperty('transition-duration');
            target.style.removeProperty('transition-property');
        }, duration);
    }
};

export const slideDown = (target: HTMLElement, duration = 600) => {
    let display = typeof window !== 'undefined' ? window.getComputedStyle(target).display : 'block';
    target.style.removeProperty('display');

    if (display === 'none') {
        display = 'block';
    }
    const height = target.offsetHeight;
    target.style.display = display;
    target.style.overflow = 'hidden';
    target.style.height = '0';
    target.style.paddingTop = '0';
    target.style.paddingBottom = '0';
    target.style.marginTop = '0';
    target.style.marginBottom = '0';
    target.offsetHeight;
    target.style.boxSizing = 'border-box';
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = `${duration}ms`;
    target.style.height = `${height}px`;
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    if (typeof window !== 'undefined') {
        window.setTimeout(() => {
            target.style.removeProperty('height');
            target.style.removeProperty('overflow');
            target.style.removeProperty('transition-duration');
            target.style.removeProperty('transition-property');
        }, duration);
    }
};
export function isValidEmail(email: string) {
    return EMAIL_REGEXP.test(email);
}
export const isValidPhone = (phone: string, hasBrackets?: boolean) => {
    /* eslint-disable no-useless-escape */
    let regex = PHONE_REGEXP;

    if (hasBrackets) regex = PHONE_BRACKETS_REGEXP;

    return regex.test(phone);
};
export const isValidName = (phone: string) => {
    /* eslint-disable no-useless-escape */
    const regex = /^[a-zA-Z\s-']*$/g;

    return regex.test(phone);
};

/** Returns the newest advertise stored based on its timestamp */
export function getAdvertiseId(gclid: any, fbclid: any, msclkid: any) {
    if (gclid) {
        gclid = JSON.parse(gclid);
        gclid.id = 'gclid';
    }

    if (fbclid) {
        fbclid = JSON.parse(fbclid);
        fbclid.id = 'fbclid';
    }

    if (msclkid) {
        msclkid = JSON.parse(msclkid);
        msclkid.id = 'msclkid';
    }

    // Filters the advertises that have a timestamp
    const advertisesWithTimestamp = [gclid, fbclid, msclkid].filter(
        (advertise) => advertise && advertise.timestamp
    );

    // Return the newest advertise based on the timestamp
    if (advertisesWithTimestamp.length) {
        return advertisesWithTimestamp.reduce((newest, advertise) => {
            return newest.timestamp > advertise.timestamp ? newest : advertise;
        });
    }

    // If none of the advertises has a timestamp return them in order.
    return gclid || msclkid || fbclid;
}

// only allow numbers inside of input
export const filterKeyPress = (e: React.KeyboardEvent) => {
    if (
        '0123456789'.indexOf(e.key) > -1 ||
        e.key.length > 1 ||
        ((e.ctrlKey || e.metaKey) && ['a', 'z', 'x', 'c', 'v'].includes(e.key))
    ) {
        return;
    }
    e.preventDefault();
};

export const removeOrphans = (str: string) => {
    if (!str.includes(' ')) return str;
    const lastspace = str.lastIndexOf(' ');
    const arr = [str.substr(0, lastspace), str.substr(lastspace + 1, str.length)];
    if (arr[1].match(/\(.+\)/g)) return str;
    return arr.join('&nbsp;');
};

export const flatListToHierarchical = (
    data = [] as any[],
    { idKey = 'key', parentKey = 'parentId', childrenKey = 'children' } = {}
) => {
    const tree = [] as any[];
    const childrenOf = {} as { [key: string]: any };
    data.forEach((item) => {
        const newItem = { ...item };
        const { [idKey]: id, [parentKey]: parentId = 0 } = newItem;
        childrenOf[id] = childrenOf[id] || [];
        newItem[childrenKey] = childrenOf[id];
        parentId
            ? (childrenOf[parentId] = childrenOf[parentId] || []).push(newItem)
            : tree.push(newItem);
    });
    return tree;
};

export function getCookie(name: string) {
    if (typeof document !== 'undefined') {
        const nameEQ = name + '=';
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
    }
    return null;
}

export function setCookie(name: string, value: string, days?: number) {
    if (typeof document !== 'undefined') {
        let expires = '';
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = '; expires=' + date.toUTCString();
        }
        document.cookie = name + '=' + (value || '') + expires + '; path=/';
    }
}

export const getColor = (color: string) => {
    const { colors } = config.theme;
    const arr = color.split('-');

    if (arr.length === 1) {
        const typedColorsVar = colors as { [key: string]: string | { [key: string]: string } };
        const val = typedColorsVar[arr[0]];

        if (typeof val === 'string') {
            return val;
        } else {
            return val['DEFAULT'];
        }
    } else {
        const typedColors = colors as { [key: string]: { [key: string]: string } };

        if (typedColors[color]) return typedColors[color];

        return typedColors[arr[0]][arr[1]];
    }
};

export const sendHotjarEvent = (eventName: string) => {
    if (!window.hj) {
        return console.error('hotjar not initialized');
    }
    window.hj('event', eventName);
};

export function getPpccParamValueByNameAndPage({
    pageCode,
    paramName,
    pageConfigs,
}: {
    pageCode?: string;
    paramName: string;
    pageConfigs?: LandingPageConfig[];
}): string | boolean | number | null {
    if (!pageConfigs || !pageCode) {
        return null;
    }
    return (
        pageConfigs.find(function filterConfigsByPageCode(x) {
            return x.pageType === pageCode && x.paramKey === paramName;
        })?.paramValue ?? null
    );
}

export function formatDate(dateString?: string): string {
    const date = dateString ? new Date(dateString) : new Date();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear().toString().padStart(2, '0');
    return `${month}/${day}/${year}`;
}

export function prefixImageLink(imageLink: string): string {
    if (
        'production' === process.env.NODE_ENV &&
        imageLink &&
        !imageLink.includes(process.env.GATSBY_PATH_PREFIX) &&
        !imageLink.includes('data:image/')
    ) {
        return `${process.env.GATSBY_PATH_PREFIX}${imageLink}`;
    }
    return imageLink;
}

export const useAccessibleTextColor = (
    bgColor: SupportedBackgroundColor,
    baseTextColor = 'text-default'
) => {
    if (bgColor.includes('dark')) {
        return 'text-surface-light';
    }
    return baseTextColor;
};

export function callInvoca(tryCount?: number) {
    let count = tryCount || 1;
    if (window.Invoca?.PNAPI?.currentPageSettings?.networkId) {
        window.Invoca.PNAPI.run();
    } else if (count < 10) {
        setTimeout(() => {
            callInvoca(++count);
        }, 300);
    }
}
